/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceQuoteRequest } from './';
import {
    FixedPriceQuoteRequestFromJSON,
    FixedPriceQuoteRequestFromJSONTyped,
    FixedPriceQuoteRequestToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteRequest } from './';
import {
    TimeAndMaterialsQuoteRequestFromJSON,
    TimeAndMaterialsQuoteRequestFromJSONTyped,
    TimeAndMaterialsQuoteRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteRequest
 */
export interface QuoteRequest {
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    clientIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    conversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    projectTermsId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    clientTermsId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    freelancerTermsAndConditions?: string;
    /**
     * 20.0
     * @type {number}
     * @memberof QuoteRequest
     */
    vatPercent?: number;
    /**
     * 
     * @type {QuoteType}
     * @memberof QuoteRequest
     */
    type: QuoteType;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    adminComment?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteRequest
     */
    projectRenewalId?: string;
}

/**
 * Check if a given object implements the QuoteRequest interface.
 */
export function instanceOfQuoteRequest(value: object): value is QuoteRequest {
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function QuoteRequestFromJSON(json: any): QuoteRequest {
    return QuoteRequestFromJSONTyped(json, false);
}

export function QuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceQuoteRequestFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteRequestFromJSONTyped(json, true);
        }
    }
    return {
        
        'clientIdentityId': json['clientIdentityId'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'title': json['title'],
        'projectTermsId': json['projectTermsId'] == null ? undefined : json['projectTermsId'],
        'clientTermsId': json['clientTermsId'] == null ? undefined : json['clientTermsId'],
        'freelancerTermsAndConditions': json['freelancerTermsAndConditions'] == null ? undefined : json['freelancerTermsAndConditions'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
        'type': QuoteTypeFromJSON(json['type']),
        'adminComment': json['adminComment'] == null ? undefined : json['adminComment'],
        'projectRenewalId': json['projectRenewalId'] == null ? undefined : json['projectRenewalId'],
    };
}

export function QuoteRequestToJSON(value?: QuoteRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceQuoteRequestToJSON(value as FixedPriceQuoteRequest);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteRequestToJSON(value as TimeAndMaterialsQuoteRequest);
        }
    }
    return {
        
        'clientIdentityId': value['clientIdentityId'],
        'conversationId': value['conversationId'],
        'title': value['title'],
        'projectTermsId': value['projectTermsId'],
        'clientTermsId': value['clientTermsId'],
        'freelancerTermsAndConditions': value['freelancerTermsAndConditions'],
        'vatPercent': value['vatPercent'],
        'type': QuoteTypeToJSON(value['type']),
        'adminComment': value['adminComment'],
        'projectRenewalId': value['projectRenewalId'],
    };
}

